import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PublicationHelper } from '../../../../helpers/publication.helper';
import { LinkifyPipe } from '../../../../pipes/linkify.pipe';
import { MentionMembersPipe } from '../../../../pipes/mention-members.pipe';
import { PublicationService } from '../../../../services/clubs/publication.service';
import { DocumentsService } from '../../../../services/dms/documents.service';
import { ClubsStore } from './../../../../clubs/clubs.store';
import { MemberApiService } from './../../../../services/clubs/member.api.service';
import { ReactionTypeService } from './../../../../services/clubs/reaction-type.service';
import { AccountsService } from './../../../../services/identity/accounts.service';
import { PostsSignalrService } from './../../../../services/signalr/posts-signalr.service';
import { AddNewCommentComponent } from './../add-new-comment/add-new-comment.component';
import { BasePostCardComponent } from './../base-post-card/base-post-card.component';

@Component({
    selector: 'app-publication-card',
    templateUrl: './publication-card.component.html',
    styleUrls: ['./publication-card.component.scss'],
    providers: [MentionMembersPipe, LinkifyPipe],
})
export class PublicationCardComponent extends BasePostCardComponent implements OnInit {
    @ViewChild('addNewCommentComponent')
    public addNewCommentComponent: AddNewCommentComponent;
    @Output() seeMoreSignal = new EventEmitter<string>();

    @Input() public initOnCommentField = false;

    constructor(
        protected override readonly accountService: AccountsService,
        override readonly clubsStore: ClubsStore,
        protected override readonly documentService: DocumentsService,
        protected override linkifyPipe: LinkifyPipe,
        protected override readonly memberService: MemberApiService,
        protected override mentionPipe: MentionMembersPipe,
        protected override readonly postsSignalrService: PostsSignalrService,
        public override readonly publicationHelper: PublicationHelper,
        protected override publicationService: PublicationService,
        protected override reactionTypeService: ReactionTypeService,
        private readonly router: Router,
        public override sanitizer: DomSanitizer,
    ) {
        super(
            accountService,
            memberService,
            publicationService,
            reactionTypeService,
            clubsStore,
            publicationHelper,
            postsSignalrService,
            documentService,
            sanitizer,
            mentionPipe,
            linkifyPipe,
        );
    }

    public get isPostRoute(): boolean {
        return this.router.url.includes('/post/');
    }

    public addComment() {
        if (window.innerWidth < 768 && !this.isPostRoute) {
            this.navigateToPost();
            return;
        }

        this.addNewCommentComponent.setFocusOnNewCommentTextArea(this.publication.owner);
    }

    public goToPostDetailPage() {
        if (this.publication.commentsCount > 0 && window.innerWidth < 768 && !this.isPostRoute && !this.isFromHomeDrawer) {
            this.navigateToPost();
        }
    }

    private navigateToPost() {
        this.router.navigate(['clubs', 'post', this.publication.id]);
    }

    public onMoreSignal(publicationId: string): void{
        this.seeMoreSignal.emit(publicationId);
    }
}
